export default __webpack_public_path__ + "static/media/IconPhone.1068713d.svg";